import { render, staticRenderFns } from "./TaskRequestCard.vue?vue&type=template&id=029c21a5"
import script from "./TaskRequestCard.vue?vue&type=script&lang=js"
export * from "./TaskRequestCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports